import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import IMenu from '../../../Interfaces/Auth/IMenu';
const MenuItems: IMenu[] = [{ id:0, descripcion:'', padreId:0, posicion:0, url:''}]
const initialState = { MenuItems }

export const MenuItemsSlice = createSlice({
  name: 'MenuItems',
  initialState: initialState,
  reducers: {
    resetMenuItems : (state, action: PayloadAction<string>) => {
      state.MenuItems =  []
    },  
    populateMenuItems : (state, action: PayloadAction<IMenu[]>) => {
      action.payload.forEach(element => {
        const index = state.MenuItems.findIndex(object => object.id === element.id)
        if (index<0) state.MenuItems.push(element)
      })
    },
  },
})

export const { resetMenuItems, populateMenuItems } = MenuItemsSlice.actions;
export default MenuItemsSlice.reducer;
